export { default } from './ProductDetailsSection'
export * from './ProductDetailsSection'
